import { testUtils } from 'mage-deps/@mpp/token-helper'
import { mount } from 'enzyme'
import { components as coreComponents } from 'mage-core'
import React from 'react'
import { Router } from 'react-router-dom'
import configureStore from 'redux-mock-store'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'

const createMockHistory = () => ({
  goBack: jest.fn(),
  location: {},
  listen: jest.fn(),
  push: jest.fn()
})

const mountComponent = Component => async ({ state = {}, props = {}, token = {}, history = { } } = {}) => {
  const mockStore = configureStore([thunk])
  const store = mockStore(state)
  const actualHistory = {
    ...createMockHistory(),
    ...history
  }
  const tokenHelper = await testUtils.createTokenHelper(token)
  return {
    component: mount(
      (
        <Router history={actualHistory}>
          <coreComponents.TokenHelperContext.Provider value={tokenHelper}>
            <Component {...props} />
          </coreComponents.TokenHelperContext.Provider>
        </Router>
      ),
      {
        wrappingComponent: Provider,
        wrappingComponentProps: { store }
      }
    ),
    store
  }
}

export {
  mountComponent
}
